__turbopack_context__.v({
  "controls": "ReviewFilters-module-scss-module__gA3jxa__controls",
  "desktopControls": "ReviewFilters-module-scss-module__gA3jxa__desktopControls",
  "filterCheckbox": "ReviewFilters-module-scss-module__gA3jxa__filterCheckbox",
  "filterRadio": "ReviewFilters-module-scss-module__gA3jxa__filterRadio",
  "mobileControls": "ReviewFilters-module-scss-module__gA3jxa__mobileControls",
  "mobileFilterTrigger": "ReviewFilters-module-scss-module__gA3jxa__mobileFilterTrigger",
  "ratingSelect": "ReviewFilters-module-scss-module__gA3jxa__ratingSelect",
  "ratingSelectOption": "ReviewFilters-module-scss-module__gA3jxa__ratingSelectOption",
  "sortSelect": "ReviewFilters-module-scss-module__gA3jxa__sortSelect",
});
